function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeWidth: 2
}, React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 1
}, React.createElement("animate", {
  attributeName: "r",
  begin: "0s",
  dur: "1.8s",
  values: "1; 20",
  calcMode: "spline",
  keyTimes: "0; 1",
  keySplines: "0.165, 0.84, 0.44, 1",
  repeatCount: "indefinite"
}), React.createElement("animate", {
  attributeName: "stroke-opacity",
  begin: "0s",
  dur: "1.8s",
  values: "1; 0",
  calcMode: "spline",
  keyTimes: "0; 1",
  keySplines: "0.3, 0.61, 0.355, 1",
  repeatCount: "indefinite"
})), React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 1
}, React.createElement("animate", {
  attributeName: "r",
  begin: "-0.9s",
  dur: "1.8s",
  values: "1; 20",
  calcMode: "spline",
  keyTimes: "0; 1",
  keySplines: "0.165, 0.84, 0.44, 1",
  repeatCount: "indefinite"
}), React.createElement("animate", {
  attributeName: "stroke-opacity",
  begin: "-0.9s",
  dur: "1.8s",
  values: "1; 0",
  calcMode: "spline",
  keyTimes: "0; 1",
  keySplines: "0.3, 0.61, 0.355, 1",
  repeatCount: "indefinite"
})));

var SvgLoadingAnimation = function SvgLoadingAnimation(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    stroke: "#fff"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDQgNDQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjZmZmIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS13aWR0aD0iMiI+PGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMSI+PGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIgYmVnaW49IjBzIiBkdXI9IjEuOHMiIHZhbHVlcz0iMTsgMjAiIGNhbGNNb2RlPSJzcGxpbmUiIGtleVRpbWVzPSIwOyAxIiBrZXlTcGxpbmVzPSIwLjE2NSwgMC44NCwgMC40NCwgMSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiLz48YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJzdHJva2Utb3BhY2l0eSIgYmVnaW49IjBzIiBkdXI9IjEuOHMiIHZhbHVlcz0iMTsgMCIgY2FsY01vZGU9InNwbGluZSIga2V5VGltZXM9IjA7IDEiIGtleVNwbGluZXM9IjAuMywgMC42MSwgMC4zNTUsIDEiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIi8+PC9jaXJjbGU+PGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMSI+PGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIgYmVnaW49Ii0wLjlzIiBkdXI9IjEuOHMiIHZhbHVlcz0iMTsgMjAiIGNhbGNNb2RlPSJzcGxpbmUiIGtleVRpbWVzPSIwOyAxIiBrZXlTcGxpbmVzPSIwLjE2NSwgMC44NCwgMC40NCwgMSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiLz48YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJzdHJva2Utb3BhY2l0eSIgYmVnaW49Ii0wLjlzIiBkdXI9IjEuOHMiIHZhbHVlcz0iMTsgMCIgY2FsY01vZGU9InNwbGluZSIga2V5VGltZXM9IjA7IDEiIGtleVNwbGluZXM9IjAuMywgMC42MSwgMC4zNTUsIDEiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIi8+PC9jaXJjbGU+PC9nPjwvc3ZnPg==";
export { SvgLoadingAnimation as ReactComponent };